/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_University_QuestionInputs */

const en_onboarding_university_question = /** @type {(inputs: Onboarding_University_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which university are you at?`)
};

const es_onboarding_university_question = /** @type {(inputs: Onboarding_University_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿En qué universidad estás?`)
};

/**
* | output |
* | --- |
* | "Which university are you at?" |
*
* @param {Onboarding_University_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_university_question = /** @type {((inputs?: Onboarding_University_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_University_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_university_question(inputs)
	return en_onboarding_university_question(inputs)
});